import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { AuthService, FileService } from '@isophi/core-legacy';
import { SupportedFileTypeService, ToastService } from '@isophi/core-ui';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';

import { environment } from '../../../environments/environment';
import { RouterLinkFactory } from '../../core/router/router-link.factory';
import { HelperService } from '../../core/services/helper.service';
import { UserService } from '../../core/services/user.service';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-export-msmt',
  templateUrl: './export-msmt.component.html',
  styleUrls: ['./export-msmt.component.scss'],
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportMsmtComponent {
  @ViewChild('toastTemplate') toastTemplate: TemplateRef<any>;

  errorMessage: string;

  public readonly links = inject(RouterLinkFactory);
  private readonly helperService = inject(HelperService);
  private readonly translocoService = inject(TranslocoService);
  private readonly spinner = inject(NgxSpinnerService);
  private readonly toastr = inject(ToastService);
  public readonly supportedFileTypeService = inject(SupportedFileTypeService);
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly fileService = inject(FileService);
  private readonly http = inject(HttpClient);

  constructor() {
    this.helperService.setTitle(null, this.translocoService.translate('settings/exportMsmt'));
  }

  exportData(): void {
    this.spinner.show();

    const url = environment.api + `/export-xml/?kindergarten_id=${this.userService.loggedKindergarten?.id}`;

    this.http
      .get(url, { responseType: 'blob' })
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (val) => {
          const today = new Date();
          const dateString = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
          this.fileService.downloadFile(val, `Export_MSMT_${dateString}.zip`, 'application/zip');
          this.toastr.success(this.translocoService.translate('settings/exportSuccess'));
        },
        error: (e) => {
          if (e.error.type === 'application/json') {
            e.error.text().then((text) => {
              this.errorMessage = this.replaceNewlinesWithBreaks(JSON.parse(text));
              this.toastr.error(this.toastTemplate, '', { autohide: false, closeOnClick: false });
            });
          } else {
            this.toastr.error(this.translocoService.translate('settings/exportError'));
          }
        },
      });
  }

  // importData(event): void {
  //   const file = event.target.files[0];

  //   if (file) {
  //     this.spinner.show();
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     this.childrenService
  //       .childrenImportCreateForm(file, 'create')
  //       .pipe(finalize(() => this.spinner.hide()))
  //       .subscribe({
  //         next: (val) => {
  //           this.toastr.success(this.translocoService.translate('settings/fileUploadSuccess'));
  //           if (!val.importedCount) {
  //             if (val.invalidValues.length) {
  //               val.invalidValues.forEach((invalidValue) => {
  //                 this.toastr.error(invalidValue);
  //               });
  //             }
  //             if (val.missingChildProfiles.length) {
  //               val.missingChildProfiles.forEach((missingChildProfile) => {
  //                 this.toastr.error(missingChildProfile);
  //               });
  //             }
  //             if (val.missingColumns.length) {
  //               val.missingColumns.forEach((missingColumn) => {
  //                 this.toastr.error(missingColumn);
  //               });
  //             }
  //           } else {
  //             this.toastr.success(this.translocoService.translate('settings/importSuccess'));
  //           }
  //         },
  //         error: (e) => {
  //           if (e.error.file) {
  //             this.toastr.error(e.error.file);
  //           } else {
  //             this.toastr.error(e.error);
  //           }
  //         },
  //       });
  //   }
  // }

  private replaceNewlinesWithBreaks(text = ''): string {
    return text.replace(/\n/g, '<br>');
  }
}
